var exports = {
  "i": "xaee3c4fa--b4f72e--wrapper",
};

module.exports = exports;
